module.exports = __webpack_public_path__ + "img/allegiant-stadium-buyout-gal-5.10f0705a.jpg";